import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { Toaster } from "sonner";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      cacheTime: 5 * 60 * 1000,
      retry: 1,
    },
    mutations: {
      onSuccess: () => {
        // When any mutation succeeds, invalidate the dashboardCounts query
        queryClient.invalidateQueries({ queryKey: ["dashboardCounts"] });
      },
    },
  },
});

export default function App({ Component, pageProps }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" richColors />
      <Component {...pageProps} />
    </QueryClientProvider>
  );
}
